// react
import { Suspense } from 'react';
import ReactDOM from 'react-dom';

// azure
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

// msal
import { config as configMsal } from './msal';

// i18n
import './i18n';

// components
import { App } from './App';

// styles
import './global.css';

// Browser translators replace text nodes with <font> wrappers, so React's removeChild/insertBefore
// target nodes that are no longer children. Tolerate that instead of crashing.
// See: https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
	const originalRemoveChild = Node.prototype.removeChild;
	Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
		if (child.parentNode !== this) return child;
		return originalRemoveChild.call(this, child) as T;
	};

	const originalInsertBefore = Node.prototype.insertBefore;
	Node.prototype.insertBefore = function <T extends Node>(
		this: Node,
		newNode: T,
		referenceNode: Node | null
	): T {
		if (referenceNode && referenceNode.parentNode !== this) return newNode;
		return originalInsertBefore.call(this, newNode, referenceNode) as T;
	};
}

// msal
const msalInstance = new PublicClientApplication(configMsal);

ReactDOM.render(
	<MsalProvider instance={msalInstance}>
		<Suspense fallback={<></>}>
			<App />
		</Suspense>
	</MsalProvider>,
	document.getElementById('root')
);
